export default __webpack_public_path__ + "assets/02bc229c0c13134e72389635a7959b99.svg";